import { FC } from "react";
import {
  HeaderLogo
} from "../../atoms";

export interface HeaderProps { }

const Header: FC<HeaderProps> = () => {
  return (
    <div className="nc-Header relative w-full z-40 ">
      <div className={`nc-MainNav2Logged relative z-10 ${"onTop "}`}>
        <div className="container py-3 relative flex justify-between items-center space-x-4 xl:space-x-8">
          <div className="flex justify-start flex-grow items-center space-x-3 sm:space-x-8 lg:space-x-10">
            <HeaderLogo />
            <div className="hidden sm:block flex-grow w-full">
              <div className="container">
                <header className="w-full mx-auto  flex flex-col ">
                 
                </header>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center justify-end text-neutral-700 dark:text-neutral-100 space-x-1">
            <div className="hidden items-center xl:flex space-x-2">
              {/* <Navigation /> */}
              <div className="flex">
                {/* <SwitchDarkMode />
                <NotifyDropdown /> */}
                {/* <span className="w-2 h-2 bg-blue-500 absolute top-2 right-2 rounded-full"></span> */}
              </div>
              {/* <Navigation /> */}
              <div></div>
              <div className="hidden sm:block h-6 border-l border-neutral-300 dark:border-neutral-6000"></div>
              <div></div>
            </div>
            <div className="flex items-center space-x-3 xl:hidden">
              {/* <NotifyDropdown />
              <AvatarDropdown /> */}
              {/* <MenuBar /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
